import React, { useState, useEffect } from 'react'
import { Modal, Form, Row, Col, Button, Radio } from 'antd'
import config from '@/utils/config'
import { SCALE_SCL90, SCALE_SAS, SCALE_SDS } from './scales'
import styles from './index.less'

const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 }
}

const EditModal = ({
  form,
  onCancel,
  onOk,
  currentScale,
  types,
  loading,
  ...other
}) => {
  const { getFieldDecorator, validateFieldsAndScroll } = form
  const { code } = currentScale
  const [scaleConfig, setScaleConfig] = useState({})
  const [resultJson, setResultJson] = useState([])

  useEffect(() => {
    if (code === 'scl90') {
      setScaleConfig(SCALE_SCL90)
    } else if (code === 'sas') {
      setScaleConfig(SCALE_SAS)
    } else if (code === 'sds') {
      setScaleConfig(SCALE_SDS)
    }
    if (currentScale.scaleAnswerRespList) {
      setResultJson([...currentScale.scaleAnswerRespList])
    }

  }, [currentScale])

  return (
    <Form>
      <Row gutter={16}>
        <Col span={24}>
          {
            (scaleConfig.items || []).map((item, index) => (
              <Form.Item className={styles.formItem} label={`${index + 1}、${item.text}`} {...formItemLayout}>
                {
                  getFieldDecorator(`${index + 1}`, {
                    initialValue: resultJson.length ? parseFloat(resultJson[index].result) : null,
                    rules: [{
                      required: true,
                      message: '必填项'
                    }]
                  })(
                    <Radio.Group buttonStyle="solid" disabled={types === 'open'}>
                      {item.values.map(i => (
                        <Radio.Button key={i.score} value={i.score}>
                          {i.text}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  )
                }
              </Form.Item>
            ))
          }
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(EditModal)
